import React from 'react';

/**
 * Placeholder orchid icon mark. Swap the <svg> below for the real brand
 * asset (see HOS Brand Guidelines, "Logo" pages) when it's available —
 * every call site renders <LogoIcon /> so a single edit here updates the
 * whole site.
 */
/**
 * Brand icon mark — the cream-colored HOS emblem sits inside a circular
 * dark olive-green badge (matching the brand book's background colour).
 * This ensures the icon is always visible regardless of the surrounding
 * page background (white header, dark footer, transparent over hero, etc.).
 */
export const LogoIcon = ({ size = 28, className = '', black = false }) => (
  <span
    className={`inline-flex items-center justify-center rounded-full overflow-hidden flex-shrink-0 ${className}`}
    style={{
      width: size,
      height: size,
      backgroundColor: 'transparent',
    }}
  >
    <img
      src="/hos-icon-fluid.png"
      alt=""
      style={{ width: '78%', height: '78%', objectFit: 'contain', filter: black ? 'brightness(0)' : undefined }}
      aria-hidden="true"
    />
  </span>
);

/**
 * Full lockup: icon + "House of Seya" wordmark, matching brand guideline
 * spacing conventions (icon above, script wordmark below).
 */
export const Logo = ({ iconSize = 28, className = '', wordmarkClassName = '' }) => (
  <div className={`flex flex-col items-center leading-none ${className}`}>
    <LogoIcon size={iconSize} className="text-current" />
    <span className={`font-script mt-1 ${wordmarkClassName}`}>House of Seya</span>
  </div>
);

export default Logo;
